class RiskFactorsSubCodes {
    public static readonly Tobacco = class {
        public static readonly Code = "RiskFactor_Tobacco";

        public static readonly NonSmoker = "NonSmoker";
        public static readonly Occasional = "Occasional";
        public static readonly OneToFiveCigarettesPerDay = "OneToFiveCigarettesPerDay";
        public static readonly FiveToTenCigarettesPerDay = "FiveToTenCigarettesPerDay";
        public static readonly TenToTwentyCigarettesPerDay = "TenToTwentyCigarettesPerDay";
        public static readonly OnePackPerDay = "OnePackPerDay";
        public static readonly OneToTwoPackPerDay = "OneToTwoPackPerDay";
        public static readonly TwoPacksPerDay = "TwoPacksPerDay";
        public static readonly TwoToThreePacksPerDay = "TwoToThreePacksPerDay";
        public static readonly ThreePacksPerDay = "ThreePacksPerDay";
        public static readonly ThreeOrMorePacksPerDay = "ThreeOrMorePacksPerDay";
        public static readonly Shisha = "Shisha";
        public static readonly Pipe = "Pipe";
    };

    public static readonly Alcohol = class {
        public static readonly Code = "RiskFactor_Alcohol";

        public static readonly NoAlcohol = "NoAlcohol";
        public static readonly Occasional = "Occasional";
        public static readonly OneToTwoCupsPerDay = "OneToTwoCupsPerDay";
        public static readonly TwoToThreeCupsPerDay = "TwoToThreeCupsPerDay";
        public static readonly ThreeToFourCupsPerDay = "ThreeToFourCupsPerDay";
        public static readonly OneBottlePerDay = "OneBottlePerDay";
        public static readonly TwoOrMoreBottlesPerDay = "TwoOrMoreBottlesPerDay";
        public static readonly DrinksPerWeek = "DrinksPerWeek";
    };

    public static readonly Drugs = class {
        public static readonly Code = "RiskFactor_Drugs";

        public static readonly NoDrugs = "NoDrugs";
        public static readonly Occasional = "Occasional";
        public static readonly DrugsCode = "Drugs";
    };

    public static readonly Coffee = class {
        public static readonly Code = "RiskFactor_Coffee";

        public static readonly NoCoffee = "NoCoffee";
        public static readonly Caffeine = "Caffeine";
        public static readonly OnetoTwoPerDay = "OnetoTwoPerDay";
        public static readonly TwoToThreePerDay = "TwoToThreePerDay";
        public static readonly ThreeToFourPerDay = "ThreeToFourPerDay";
        public static readonly MoreThanFourPerDay = "MoreThanFourPerDay";
    };

    public static readonly MaritalStatus = class {
        public static readonly Code = "RiskFactor_MaritalStatus";

        public static readonly Single = "Single";
        public static readonly Married = "Married";
        public static readonly Divorced = "Divorced";
        public static readonly NoChildren = "NoChildren";
    };

    public static readonly Job = class {
        public static readonly Code = "RiskFactor_Job";

        public static readonly DeskJob = "DeskJob";
        public static readonly PhysicalJob = "PhysicalJob";
        public static readonly Unemployed = "Unemployed";
        public static readonly Welfare = "Welfare";
    };

    public static readonly Sports = class {
        public static readonly Code = "RiskFactor_Sports";

        public static readonly DoesSports = "DoesSports";
        public static readonly Competitive = "Competitive";
        public static readonly PhysicalInactivity = "PhysicalInactivity";
        public static readonly Obesity = "Obesity";
    };

    public static readonly Diet = class {
        public static readonly Code = "RiskFactor_Diet";

        public static readonly Healthy = "Healthy";
        public static readonly Unhealthy = "Unhealthy";
        public static readonly RichInFat = "RichInFat";
        public static readonly RichInSalt = "RichInSalt";
    };

    public static readonly Food = class {
        public static readonly Code = "RiskFactor_Food";

        public static readonly ConsumesLessThanThreeMealsPerDay = "ConsumesLessThanThreeMealsPerDay";
        public static readonly ConsumesLessThanFivePortionsOfFruitsVegetablesPerDay = "ConsumesLessThanFivePortionsOfFruitsVegetablesPerDay";
        public static readonly ConsumesGrapefruit = "ConsumesGrapefruit";
    };

    public static readonly BreastFeeding = class {
        public static readonly Code = "RiskFactor_BreastFeeding";

        public static readonly BreastFeedingSubCode = "BreastFeeding";
    };

    public static readonly BloodDonation = class {
        public static readonly Code = "RiskFactor_BloodDonation";

        public static readonly BloodDonationCode = "BloodDonation";
    };

    public static readonly Medications = class {
        public static readonly Code = "RiskFactor_Medications";

        public static readonly TakesCrushedForm = "TakesCrushedForm";
        public static readonly TakesLiquidForm = "TakesLiquidForm";
    };

    public static readonly Ostomy = class {
        public static readonly Code = "RiskFactor_Ostomy";

        public static readonly OstomyCode = "Ostomy";
    };

    public static readonly ContactLenses = class {
        public static readonly Code = "RiskFactor_ContactLenses";

        public static readonly ContactLensesCode = "ContactLenses";
    };
}

export { RiskFactorsSubCodes };
